module.exports = __webpack_public_path__ + "img/sowhatbuy-reward.2c23f3f7.jpg";